import React from 'react';
import styles from './Loader.module.css';

const Loader = () => {
  return (
    <div className={styles.loaderContainer}>
      <div className={styles.gheeDropper}>
        <div className={styles.spoon}>🥄</div>
        <div className={styles.drop}></div>
        <div className={styles.drop} style={{ animationDelay: '0.5s' }}></div>
        <div className={styles.drop} style={{ animationDelay: '1s' }}></div>
      </div>
      <h2 className={styles.loadingText}>
        <span className="gujarati-text">બાહરીયા ફાર્મ</span>
        <br />
        Bahariya Farm
      </h2>
      <p className={styles.tagline}>Loading Pure Tradition...</p>
    </div>
  );
};

export default Loader;
